export enum MetaEventType {
    PAGE_VIEW = "PAGE_VIEW",
    COMPLETE_REGISTRATION = "COMPLETE_REGISTRATION",
    PURCHASE = "PURCHASE",
    LEAD = "LEAD",
    INITIATE_CHECKOUT = "INITIATE_CHECKOUT",
    ADD_TO_CART = "ADD_TO_CART",
    VIEW_CONTENT = "VIEW_CONTENT",
    SEARCH = "SEARCH",
    ADD_PAYMENT_INFO = "ADD_PAYMENT_INFO",
    ADD_TO_WISHLIST = "ADD_TO_WISHLIST",
    CONTACT = "CONTACT",
    SUBSCRIBE = "SUBSCRIBE",
    START_TRIAL = "START_TRIAL"
}
